import React from 'react';
import {DmsTab, RegionCascader} from 'Components';
import {hashHistory} from 'react-router';
import {Form, Input, Select, Button, Row, Col, message, Cascader, DatePicker} from 'antd';
import {showSpin, hideSpin} from 'Utils';
import moment from 'moment';

const Option = Select.Option;
const FormItem = Form.Item;
import {
    fetchArea,
    fetchCity,
    fetchChannels,
    saveOrUpdate,
    detail,
    treeList2,
    fetchLine,
    fetchCustomer,
    fetchSubdivideProLine
} from '../../service/billingCtrl';
import {fetchAllBusinessLineList} from "../../service/home";


class BillingAdd extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: parseInt(this.props.params.channelId, 10),
            opts: ['开单管控配置'],
            detail: {},
            detail2: {},
            mainId: '',
            middleId: '',
            detailId: '',
            productClassify: [],
            area: [],
            city: [],
            channel: [],
            business: [],
            categoryTree: [],
            productLine: [],
            categoryIds: [],
            subdivideProLine: [],
            customer: [],
            detailNum: [],
            channelChangeId: '',
            areaChangeId: '',
            regionChangeId: '',
            detailName: '',
            customerId: '',
            subdivideProLineCode: '',
            startDate: '',
            endDate: '',
            businessLine: '',
            businessLineName: ''
        }
    }

    // componentWillMount(){
    // 	const self = this;
    // 	fetchLine().then(res => { //物料类别
    // 	    if(res.status){
    // 	    	// debugger
    // 	    	// console.log(res)

    // 	       var arr = new Array();
    // 	       // for (var i = 0; i <= res.length ; i ++ ) {
    // 	       // 	arr[i].name=res[i].name,
    // 	       //     arr[i].id=res[i].id
    // 	       // }
    // 	        res.data.forEach(x => {
    // 	            arr.push({
    // 	                name: x.name,
    // 	                id: x.id
    // 	            })
    // 	        });
    // 		self.setState({productLine: arr})
    // 	// 			debugger
    // 	// console.log(self.state.productLine)
    // 	    }
    // 	});


    // }

    componentDidMount() {
        let id = +this.props.params.addId;
        if (id !== 0) {
            /* 编辑 */
            this.getArea(() => {
                this.getDetail(id);
            })
        } else {
            this.setState({
                opts: ['开单管控设置'],
                detail: {}
            });
            // 获取片区
            this.getArea();
        }
        this.getChannels();
        this.getProductLine();
        this.getCategory();
        this.getCustomer();
        this.getSubdivideProLine();
        this.getBusinessLine();
    }

    getDetail = (id) => {
        let self = this;
        detail({id: id}).then(result => {
            if (result.status && result.code == 200) {
                if (result.data.mainNum) {
                    self.state.productClassify.push(String(result.data.mainId));
                    self.state.detailNum.push(String(result.data.mainNum));
                    if (result.data.middleNum) {
                        self.state.productClassify.push(String(result.data.middleId));
                        self.state.detailNum.push(String(result.data.middleNum));
                        if (result.data.detailNum) {
                            self.state.productClassify.push(String(result.data.detailId));
                            self.state.detailNum.push(String(result.data.detailNum));
                        }
                    }
                }
                result.data.categoryId = self.state.productClassify;
                result.data.detailNum = self.state.detailNum;
                self.setState({
                    detail: result.data,
                    channelChangeId: result.data.channelCode,
                    areaChangeId: result.data.areaId,
                    regionChangeId: result.data.regionId,
                    customerId: result.data.customerId,
                    subdivideProLineCode: result.data.subdivideProLine,
                    startDate: result.data.startDate,
                    endDate: result.data.endDate,
                    detailName: result.data.detailName,
                    businessLine: result.data.businessLine,
                    businessLineName: result.data.businessLineName
                });

            } else {
                message.error(result.message);
            }
        });
    }

    initProductSpecFn(val, selectedOptions) {
        // 根据 产品分类查询 产品规格
        if (val.length == 0) {
            return;
        }
        val = val[val.length - 1];
        this.setState({detailName: selectedOptions[2].label});
    }

    getArea = (cb) => {
        fetchArea().then(result => {
            if (result.status && result.code == 200) {
                result.data.push({key: 9999999, lable: '', code: ''});
                cb ? this.setState({area: result.data}, cb) : this.setState({area: result.data});
            } else {
                message.error(result.message);
            }
        });
    }
    getCategory = (cb) => {
        const self = this;
        treeList2('').then(result => {
            if (result.status && result.code == 200) {
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].value = result.data[i].code;
                    for (var j = 0; j < result.data[i]['children'].length; j++) {
                        result.data[i]['children'][j].value = result.data[i]['children'][j].code;
                        for (var z = 0; z < result.data[i]['children'][j]['children'].length; z++) {
                            result.data[i]['children'][j]['children'][z].value = result.data[i]['children'][j]['children'][z].code;
                            delete result.data[i]['children'][j]['children'][z].children;
                        }
                    }
                }
                cb ? this.setState({categoryTree: result.data}, cb) : this.setState({categoryTree: result.data});
            } else {
                message.error(result.message);
            }
        });
    }
    getProductLine = (cb) => {
        fetchLine().then(result => {
            if (result.status && result.code == 200) {
                result.data.push({id: 9999999, name: '', code: ''});
                cb ? this.setState({productLine: result.data}, cb) : this.setState({productLine: result.data});
            } else {
                message.error(result.message);
            }
        });
    }

    getChannels = () => {
        fetchChannels().then(result => {
            if (result.status && result.code == 200) {
                result.data.push({id: 9999999, name: '', code: ''});
                this.setState({channel: result.data});
            } else {
                message.error(result.message);
            }
        });
    }

    getBusinessLine = () => {
        fetchAllBusinessLineList().then(result => {
            if (result.status && result.code == 200) {
                result.data.push({id: 9999999, name: '', code: ''});
                this.setState({business: result.data});
            } else {
                message.error(result.message);
            }
        });
    }

    getSubdivideProLine = () => {
        fetchSubdivideProLine().then(result => {
            if (result.status && result.code == 200) {
                result.data.push({id: 9999999, name: '', code: ''});
                this.setState({subdivideProLine: result.data});
            } else {
                message.error(result.message);
            }
        });
    }

    getCustomer = () => {
        fetchCustomer().then(result => {
            if (result.status && result.code == 200) {
                result.data.push({id: 9999999, NAME: '', CODE: ''});
                this.setState({customer: result.data});
            } else {
                message.error(result.message);
            }
        });
    }

    cancelHandle() {
        hashHistory.goBack();
    }

    submitHandle() {
        const {validateFields, getFieldsValue} = this.props.form;
        const self = this;
        validateFields((errors) => {//表单校验
            if (errors) {
                return
            }//表单校验有误，则不执行下面的代码
            const data = {
                ...getFieldsValue() //获取用户输入
            };
            var _id = this.props.params.addId;

            if (_id) {
                data.id = _id;
            }
            // console.log(data);
            // debugger
            data.mainId = data.categoryId[0];
            data.middleId = data.categoryId[1];
            data.detailId = data.categoryId[2];
            data.channelCode = self.state.channelChangeId;
            data.areaId = self.state.areaChangeId;
            data.regionId = self.state.regionChangeId;
            data.detailName = self.state.detailName;
            data.startDate = moment(self.state.startDate).format("YYYY-MM-DD");
            data.endDate = moment(self.state.endDate).format("YYYY-MM-DD");
            self.state.subdivideProLine.forEach(item => {
                if (item.CODE == data.subdivideProLine) {
                    data.subdivideProLineName = item.NAME
                }
            });
            data.businessLine = self.state.businessLine;
            self.state.business.forEach(item => {
                if (item.code == data.businessLine) {
                    data.businessLineName = item.name
                }
            });

            // data.detailNum = '';
            delete data.categoryId;
            if (data.id == 0) {
                data.id = '';
            }
            saveOrUpdate(data).then(result => {
                if (result.status && result.code == 200) {
                    message.success(result.message);
                    if (result.message == "操作成功") {
                        hashHistory.goBack();
                    }
                } else {
                    message.error(result.message);
                }
            })
        })

    }

    areaChange = (value) => {
        // console.log('Selected area id is: ' + value);
        this.setState({areaChangeId: value});
        fetchCity({id: value}).then(result => {
            if (result.status && result.code == 200) {
                result.data.push({key: 9999999, lable: '', code: ''});
                this.setState({
                    city: result.data
                });
            } else {
                message.error(result.message);
            }
        });
    }

    CascaderFilter = (inputValue, path) => {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    }

    businessChange = (value) => {
        this.setState({businessLine: value});
    }
    channelChange = (value) => {
        this.setState({channelChangeId: value});
    }
    regionChange = (value) => {
        this.setState({regionChangeId: value});
    }
    customerChange = (value) => {
        this.setState({customerId: value});
    }

    subdivideProLineChange = (value) => {
        this.setState({subdivideProLineCode: value});
    }

    onChange = (value, selectedOptions) => {
        console.log(value, selectedOptions);
    }

    startDateChange = (value) => {
        this.setState({startDate: value});
    }

    endDateChange = (value) => {
        this.setState({endDate: value});
    }

    disabledStartDate = (startValue) => {
        const endValue = this.state.endDate;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    }

    disabledEndDate = (endValue) => {
        const startValue = this.state.startDate;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    }

    loadData = (selectedOptions) => {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;

        setTimeout(() => {
            targetOption.loading = false;
            targetOption.children = [{
                label: `${targetOption.label} Dynamic 1`,
                value: 'dynamic1',
            }, {
                label: `${targetOption.label} Dynamic 2`,
                value: 'dynamic2',
            }];
            this.setState({
                options: [...this.state.options],
            });
        }, 1000);
    }

    setCategoryIdAdd(val) {
        let arr = [];
        arr.push(val.mainId)
        arr.push(val.middleId)
        arr.push(val.detailId)
        this.setState({
            categoryIds: arr,
        });
    }

    render() {
        const {
            opts,
            detail,
            detail2,
            area,
            city,
            channel,
            id,
            productLine,
            categoryTree,
            categoryIds,
            subdivideProLine,
            customer,
            mainId,
            productClassify,
            middleId,
            detailId,
            business
        } = this.state;
        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {span: 3},
            wrapperCol: {span: 12, offset: 1}
        };
        return <div className='dms-body'>
            <DmsTab options={opts} defaultKey={0}>
                <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
                <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
            </DmsTab>
            <div className="dms-table-box" style={{backgroundColor: "#fff"}}>
                <Form layout="horizontal">
                    <Row>
                        <Col className="gutter-row" span={12} id="categoryIdAdd">
                            <FormItem label="产品分类：">
                                {getFieldDecorator('categoryId', {
                                    initialValue: detail.detailNum || [],
                                    rules: [
                                        {
                                            type: 'array',
                                            required: false,
                                            message: '请选择产品分类'
                                        }
                                    ],
                                })(
                                    <Cascader options={categoryTree} onChange={this.initProductSpecFn.bind(this)}
                                              style={{width: 400}}
                                              placeholder="请选择产品分类"
                                              showSearch={{filter: this.CascaderFilter}}
                                              getPopupContainer={() => document.getElementById('categoryIdAdd')}/>)}
                            </FormItem>
                        </Col>

                        <Col className="gutter-row" span={12}>
                            <FormItem label="细分产品线：">
                                {getFieldDecorator('subdivideProLine', {
                                    initialValue: (detail !== null && detail.subdivideProLine) ? detail.subdivideProLine : '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入细分产品线'
                                        }
                                    ]
                                })(
                                    <Select style={{width: 400}} onChange={this.subdivideProLineChange.bind(this)}
                                            value={this.state.subdivideProLineCode}>
                                        {subdivideProLine.map(function (item, index) {
                                            return <Select.Option key={index + ''}
                                                                  value={item.CODE}>{item.NAME} </Select.Option>;
                                        })}
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="区域：">
                                {getFieldDecorator('areaId', {
                                    initialValue: (detail !== null && detail.areaName) ? detail.areaName : '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入区域'
                                        }
                                    ]
                                })(
                                    <Select style={{width: 400}} onChange={this.areaChange.bind(this)}
                                            value={this.state.areaChangeId}>
                                        {area.map(function (item, index) {
                                            return <Select.Option key={index + ''}
                                                                  value={item.code}>{item.label}</Select.Option>;
                                        })}
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="省市：">
                                {getFieldDecorator('regionId', {
                                    initialValue: (detail !== null && detail.regionName) ? detail.regionName : '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请选择省市'
                                        }
                                    ]
                                })(
                                    <Select style={{width: 400}} onChange={this.regionChange.bind(this)}
                                            value={this.state.regionChangeId}>
                                        {city.map(function (item, index) {
                                            return <Select.Option key={index + ''}
                                                                  value={item.code}>{item.label}</Select.Option>;
                                        })}
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                    <Row>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="客户名称：">
                                {getFieldDecorator('customerId', {
                                    initialValue: (detail !== null && detail.customerId) ? detail.customerId : '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入客户名称'
                                        }
                                    ]
                                })(
                                    <Select style={{width: 400}} showSearch
                                            onChange={this.customerChange.bind(this)}
                                            value={this.state.customerId}
                                            optionFilterProp="children"
                                    >
                                        {customer.map(function (item, index) {
                                            return <Select.Option key={index + ''}
                                                                  value={item.code}>{item.name} </Select.Option>;
                                        })}
                                    </Select>
                                )}
                            </FormItem>
                        </Col>

                        {/*<Col className="gutter-row" span={12}>*/}
                        {/*    <FormItem label="渠道">*/}
                        {/*        {getFieldDecorator('channelCode', {*/}
                        {/*            initialValue: (detail !== null && detail.channelName) ? detail.channelName : '',*/}
                        {/*            rules: [*/}
                        {/*                {*/}
                        {/*                    required: false,*/}
                        {/*                    message: '请选择渠道'*/}
                        {/*                }*/}
                        {/*            ]*/}
                        {/*        })(<Select style={{width: 400}} onChange={this.channelChange.bind(this)}*/}
                        {/*                   value={this.state.channelChangeId}>*/}
                        {/*            {channel.map(function (cur, ind) {*/}
                        {/*                return <Option key={ind} value={cur.code + ''}>{cur.name}</Option>;*/}
                        {/*            })}*/}
                        {/*        </Select>)}*/}
                        {/*    </FormItem>*/}
                        {/*</Col>*/}

                        <Col className="gutter-row" span={12}>
                            <FormItem label="业务线">
                                {getFieldDecorator('businessLine', {
                                    initialValue: (detail !== null && detail.businessLineName) ? detail.businessLineName : '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请选择业务线'
                                        }
                                    ]
                                })(<Select style={{width: 400}} onChange={this.businessChange.bind(this)}
                                           value={this.state.businessLine}>
                                    {business.map(function (cur, ind) {
                                        return <Option key={ind} value={cur.code}>{cur.name}</Option>;
                                    })}
                                </Select>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="起始日期">
                                {getFieldDecorator('startDate', {
                                    initialValue: (detail !== null && detail.startDate) ? moment(moment.unix(detail.startDate / 1000), 'YYYY-MM-DD') : '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请选择起始日期'
                                        }
                                    ]
                                })(<DatePicker style={{width: 400}} onChange={this.startDateChange.bind(this)}
                                               disabledDate={this.disabledStartDate.bind(this)}
                                               value={this.state.startDate}>
                                </DatePicker>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="结束日期">
                                {getFieldDecorator('endDate', {
                                    initialValue: (detail !== null && detail.endDate) ? moment(moment.unix(detail.endDate / 1000), 'YYYY-MM-DD') : '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请选择结束日期'
                                        }
                                    ]
                                })(<DatePicker style={{width: 400}} onChange={this.endDateChange.bind(this)}
                                               disabledDate={this.disabledEndDate.bind(this)}
                                               value={this.state.endDate}>
                                </DatePicker>)}
                            </FormItem>
                        </Col>
                    </Row>

                </Form>
            </div>
        </div>
    }
}

export default Form.create()(BillingAdd)


// WEBPACK FOOTER //
// ./src/routes/billingCtrl/add.js